import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GuideSearch from './GuideSearch';
import UserGuideViewer from './UserGuideViewer';
import './UserGuide.css';

/**
 * Main UserGuide Manager component
 * Handles switching between search and guide viewing
 * Can be embedded anywhere in the app or used as a standalone page
 */
const UserGuideManager = ({ 
  initialGuideId = null, 
  initialSearchQuery = '',
  showBackToSearch = true,
  onGuideComplete = null,
  className = ''
}) => {
  const { t } = useTranslation();
  const [currentGuideId, setCurrentGuideId] = useState(initialGuideId);
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);

  const handleGuideSelect = (guideId) => {
    setCurrentGuideId(guideId);
  };

  const handleBackToSearch = () => {
    setCurrentGuideId(null);
    if (onGuideComplete) {
      onGuideComplete();
    }
  };

  const handleGuideClose = () => {
    if (showBackToSearch) {
      handleBackToSearch();
    } else if (onGuideComplete) {
      onGuideComplete();
    }
  };

  return (
    <div className={`user-guide-manager ${className}`}>
      {currentGuideId ? (
        <UserGuideViewer 
          guideId={currentGuideId} 
          onClose={showBackToSearch ? handleGuideClose : onGuideComplete}
        />
      ) : (
        <GuideSearch 
          onGuideSelect={handleGuideSelect}
          searchQuery={searchQuery}
          autoSearch={!!initialSearchQuery}
        />
      )}
    </div>
  );
};

export default UserGuideManager;

